import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import useGetThrowablesAndEmojis from "@/src/hooks/data/useGetThrowablesAndEmojis";
import LottieAnimation from "../LottieAnimation/LottieAnimation";
import usePlayerDetails from "@/src/hooks/data/usePlayerDetails";
import usePlayerStats from "@/src/hooks/data/usePlayerStats";
import { PLAYER_STATS } from "@/Poker/data/Constants";
import useTableSettings from "@/src/hooks/data/useTableSettings";

export default function A23PlayerStats({ tempTableId }) {
  const { getListOfAvailableThrowables, sendEmoji } =
    useGetThrowablesAndEmojis();
  const { userName } = usePlayerDetails();
  const [open, setOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(0);
  const { modalType, closePlayerStats } = usePlayerStats(tempTableId);
  const { tableSettings } = useTableSettings();
  const throwables = getListOfAvailableThrowables();

  useEffect(() => {
    if (modalType === PLAYER_STATS) {
      setOpen(true);
      setVisibleCount(0);

      const batchSize = 6;
      const interval = setInterval(() => {
        setVisibleCount((prev) => {
          if (prev >= throwables.length) {
            clearInterval(interval);
            return prev;
          }
          return prev + batchSize;
        });
      }, 100);
    }

    return () => {
      setOpen(false);
      // setVisibleCount(0);
    };
  }, [modalType]);

  const handleEmojiClick = (throwableId) => {
    sendEmoji(throwableId, userName, tempTableId);
    setOpen(false);
  };

  const closeStatsDrawer = () => {
    setOpen(false);
    closePlayerStats();
  };
  console.log("TABLE_SETTINGS-->", tableSettings);

  const renderEmojisContainer = () => {
    return (
      tableSettings?.showEmojis && (
        <div className='overflow-y-auto min-h-[400px] max-h-[400px] p-2 mb-1'>
          <div className='grid grid-cols-3 gap-2'>
            {throwables.map((throwable, index) => (
              <div
                key={throwable.id}
                className='w-full aspect-square flex items-center justify-center'
                onClick={() =>
                  index < visibleCount && handleEmojiClick(throwable.id)
                }
              >
                {index < visibleCount ? (
                  <LottieAnimation
                    animationSource={throwable.emoji}
                    size='100%'
                    loop
                    autoPlay
                  />
                ) : (
                  <div className='w-4/5 h-4/5 rounded-lg bg-[var(--color-accent)]  animate-pulse' />
                )}
              </div>
            ))}
          </div>
        </div>
      )
    );
  };

  return (
    <Dialog open={open} onOpenChange={closeStatsDrawer}>
      <DialogContent>
        <DialogTitle>My Stats</DialogTitle>
        {renderEmojisContainer()}
      </DialogContent>
    </Dialog>
  );
}
// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "../../components/ui/dialog";
// import useGetThrowablesAndEmojis from "@/src/hooks/data/useGetThrowablesAndEmojis";
// import LottieAnimation from "../LottieAnimation/LottieAnimation";
// import usePlayerDetails from "@/src/hooks/data/usePlayerDetails";
// import usePlayerStats from "@/src/hooks/data/usePlayerStats";
// import { PLAYER_STATS } from "@/Poker/data/Constants";

// export default function A23PlayerStats({ tempTableId }) {
//   const { getListOfAvailableThrowables, sendEmoji } =
//     useGetThrowablesAndEmojis();
//   const { userName } = usePlayerDetails();
//   const [open, setOpen] = useState(false);
//   const [showEmoji, setShowEmoji] = useState(false);
//   const { modalType, closePlayerStats } = usePlayerStats(tempTableId);
//   useEffect(() => {
//     if (modalType === PLAYER_STATS) {
//       setOpen(true);
//       setTimeout((timeoutId) => {
//         setShowEmoji(true);
//         clearTimeout(timeoutId);
//       }, 100);
//     }
//     return () => {
//       setOpen(false);
//       setShowEmoji(false);
//     };
//   }, [modalType]);

//   const handleEmojiClick = (throwableId) => {
//     sendEmoji(throwableId, userName, tempTableId);
//     setOpen(false);
//   };

//   const closeStatsDrawer = () => {
//     setOpen(false);
//     closePlayerStats();
//   };

//   return (
//     <Dialog open={open} onOpenChange={closeStatsDrawer}>
//       <DialogContent>
//         <DialogTitle>My Stats</DialogTitle>

//         {/* <DialogDescription> */}
//         <div className='overflow-y-auto min-h-[400px] max-h-[400px] p-2 mb-1'>
//           {showEmoji && (
//             <div className='grid grid-cols-3 gap-2'>
//               {getListOfAvailableThrowables().map((throwable) => (
//                 <div
//                   key={throwable.id}
//                   className='w-full aspect-square flex items-center justify-center'
//                   onClick={() => {
//                     handleEmojiClick(throwable.id);
//                   }}
//                 >
//                   <LottieAnimation
//                     animationSource={throwable.emoji}
//                     size='100%'
//                     loop={true}
//                     autoPlay={true}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//         {/* </DialogDescription> */}
//       </DialogContent>
//     </Dialog>
//   );
// }
